const steps = ["Connect", "Understand", "Build", "Grow", "Scale"] as const;

/** Recurring Connect → Understand → Build → Grow → Scale graphic. `active` highlights one step. */
export function Framework({ active, tone = "light" }: { active?: (typeof steps)[number]; tone?: "light" | "dark" }) {
  const dark = tone === "dark";
  return (
    <ol className="flex flex-wrap items-center gap-x-3 gap-y-2 font-mono text-[11px] uppercase tracking-[0.25em]">
      {steps.map((s, i) => {
        const on = active === s;
        return (
          <li key={s} className="flex items-center gap-3">
            <span className={`flex items-center gap-2 ${on ? (dark ? "text-navy-foreground" : "text-primary") : dark ? "text-navy-foreground/60" : "text-muted-foreground"}`}>
              <span className={`grid h-6 w-6 place-items-center border text-[10px] ${on ? "border-primary bg-primary text-primary-foreground" : dark ? "border-navy-foreground/30" : "border-border"}`}>{String(i + 1).padStart(2, "0")}</span>
              {s}
            </span>
            {i < steps.length - 1 && <span className={`h-px w-6 ${dark ? "bg-navy-foreground/30" : "bg-border"}`} />}
          </li>
        );
      })}
    </ol>
  );
}

export function SdvosbBadge({ tone = "light" }: { tone?: "light" | "dark" }) {
  const dark = tone === "dark";
  return (
    <span className={`inline-flex items-center gap-2 border px-3 py-1.5 font-mono text-[10px] uppercase tracking-[0.25em] ${dark ? "border-navy-foreground/30 text-navy-foreground/90" : "border-primary/40 text-primary"}`}>
      <span className="h-1.5 w-1.5 bg-primary" />
      Service-Disabled Veteran-Owned Small Business
    </span>
  );
}
